module.exports = __webpack_public_path__ + "img/2-4.bbc4670c.png";